// 商品是否需要发货
export let shippingMode = [
  {
    label: '实体商品（需发货）',
    value: 'EXPRESS'
  },
  {
    label: '虚拟商品',
    value: 'ONLINE'
  },
  {
    label: '无需发货',
    value: 'NONE'
  }
]
// 兑换积分商品周期枚举
export let exchangeTimeDimensions = [
  {
    label: '天',
    value: 'DAYS'
  },
  {
    label: '月',
    value: 'MONTH'
  },
  {
    label: '季度',
    value: 'QUARTER'
  },
  {
    label: '年',
    value: 'YEARS'
  }
]
